import { useState } from 'react'
import ElectricalServicesOutlinedIcon from '@mui/icons-material/ElectricalServicesOutlined'
import Box from '@mui/material/Box'

import { BottomButtons, StepIcon } from './wizard-common'
import SocketWizard from '@/components/socket-wizard'
import { PreviousStepButton } from '../components'
import FinishButton from '@/components/socket-wizard/finish-button'
import { useApplianceControls } from '@/hooks/use-appliance-control'

export function WizardStep9({
    goBack,
    estateId,
    applianceId,
}: {
    applianceId: number
    estateId: number
    goBack: () => void
}) {

    const [success, setSuccess] = useState<boolean>(false)

    const { data } = useApplianceControls(applianceId)

    const enabled = success || (data && data.length > 0)

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
        }}>
            <StepIcon icon={<ElectricalServicesOutlinedIcon />} color={'#ffecdb'} />

            <SocketWizard
                applianceId={applianceId}
                successCallback={setSuccess}
            />

            <Box pt={2}>
                <BottomButtons>
                    <Box sx={{ flex: 1 }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}>
                            <PreviousStepButton
                                onClick={() => {
                                    goBack()
                                }}
                            >
                                Zpět
                            </PreviousStepButton>

                            <FinishButton
                                estateId={estateId}
                                applianceId={applianceId}
                                disabled={!enabled}
                            />
                        </Box>
                    </Box>
                </BottomButtons>
            </Box>
        </Box>
    )
}
